import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const GraphView = ({ graphData }) => {
  if (!graphData || Object.keys(graphData).length === 0) return null;

  const labels = Object.keys(graphData);

  const data = {
    labels,
    datasets: [
      {
        label: "Quantity",
        data: Object.values(graphData),
        backgroundColor: ["#86efac", "#fdba74", "#93c5fd"],
        borderColor: "transparent",
        borderRadius: 10,
        barThickness: 50,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: "Quantity per Area",
        color: "#1e293b",
        font: {
          size: 16,
          weight: "600",
        },
        padding: {
          bottom: 20,
        },
      },
      tooltip: {
        backgroundColor: "#0f172a",
        titleColor: "#fff",
        bodyColor: "#fff",
        padding: 10,
      },
    },
    scales: {
      x: {
        ticks: {
          color: "#475569",
          font: {
            weight: "500",
          },
        },
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          color: "#475569",
        },
        grid: {
          color: "#e2e8f0",
        },
      },
    },
  };

  return (
    <div className="dashboard-chart-wrap">
      <Bar options={options} data={data} />
    </div>
  );
};

export default GraphView;